import React from 'react'
import MenuItem from '@mui/material/MenuItem'
import TextField, { TextFieldProps } from '@mui/material/TextField'

export type SelectFieldProps = {
  description?: string
  menuItems: { value: string | number; label: string }[] | undefined
  className?: string
  disabled?: boolean
  defaultValue?: string | number
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  error?: boolean
  rightIcon?: boolean
} & Omit<TextFieldProps, 'error'>

export const SelectField = React.forwardRef<HTMLDivElement, SelectFieldProps>(
  (
    {
      description = '',
      helperText,
      menuItems,
      className,
      disabled,
      defaultValue,
      error = false,
      rightIcon = false,
      onChange,
      ...field
    }: SelectFieldProps,
    ref
  ) => {
    return (
      <TextField
        select
        label={description}
        variant="outlined"
        className={className}
        onChange={onChange}
        disabled={disabled}
        defaultValue={defaultValue}
        error={error}
        helperText={helperText}
        InputProps={{
          style: {
            fontFamily: 'BB-Font-Regular',
            fontSize: '16px'
          }
        }}
        SelectProps={{
          style: {
            fontFamily: 'BB-Font-Regular',
            fontSize: '16px',
            paddingLeft: rightIcon ? '25px' : undefined,
            fontWeight: 'bold',
            paddingRight: '5px'
          }
        }}
        InputLabelProps={{
          style: {
            fontFamily: 'BB-Font-Regular'
          }
        }}
        sx={
          rightIcon
            ? {
                '& .MuiSvgIcon-root': {
                  left: '8px'
                },
                '& .MuiInputLabel-root': {
                  left: '0px'
                },
                '& .MuiInputLabel-formControl': {
                  paddingLeft: '25px'
                },
                '& .MuiInputLabel-shrink ': {
                  paddingLeft: '0px'
                }
              }
            : {}
        }
        inputRef={ref}
        {...field}
      >
        {menuItems &&
          menuItems?.length > 0 &&
          menuItems?.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
              style={{
                fontFamily: 'BB-Font-Regular'
              }}
            >
              {option.label}
            </MenuItem>
          ))}
      </TextField>
    )
  }
)

SelectField.displayName = 'SelectField'
